module.exports = __webpack_public_path__ + "img/phone-flip-solid.1935f349.svg";